import {
  observable,
  computed,
  configure,
  action,
  //autorun,
  makeObservable,
} from "mobx";
import { createContext } from "react";

configure({
  enforceActions: "observed",
  useProxies: "ifavailable",
  // computedRequiresReaction: true,
  // reactionRequiresObservable: true,
  // observableRequiresReaction: true,
});

//import $ from 'jquery';
import { readCookie } from "lib/cookies";

/*
 station_id,
 station,
 artist,
 artist_id,
 band_id,
 song,
 song_id,
 jango_can,
 monetized,
 targeted_artist_id,
 airplay_song_id,
 similar_stations,
 recent_stations,
 station_name,
 limited_station_name,
 video_id,
 video_link,
 ytrid,
 music_path,
 album,
 tweet,
 twandle,
 bio,
 lyrics,
 lyrics_url,
 cb,
 ver,
 tags,
 stype,
 url,
 message,
 session_plays,
 session_skips,
 survey,
 allow_explicit
 */

class PlayerStore {
  songInfo = {};
  songTime = 0;
  duration = 0;
  paused = false;
  volume = 1.0;
  loading = true;
  shuffle = true;
  user_id = 0;
  pathname = null; //location.pathname;
  prevPathname = null;
  autoplayable = false;
  mdc = 2;
  mdc100 = 50;
  autoplayOverlay = null;
  tourVisible = false;
  freakingOut = false;
  //idle = false;
  working = false;
  airplayThumbsOpen = false;
  autoplayOverlayVariant = null;
  defaultAlbumArtPalette = {
    light: [238, 238, 238],
    dark: [153, 153, 153],
  };
  albumArtPalette = null;
  landingPathname = null;
  signUpOpen = false;
  logInOpen = false;
  airplayUX = false;
  resuming = false;
  not_found_artist_name = null;
  station_error = null;
  playerStopTrigger = 0;
  tooManySkipsMessageOpen = null;
  snackCopy = null;
  youtubeID = null;

  constructor() {
    makeObservable(this, {
      songInfo: observable,
      songTime: observable,
      duration: observable,
      paused: observable,
      volume: observable,
      loading: observable,
      shuffle: observable,
      user_id: observable,
      pathname: observable,
      prevPathname: observable,
      autoplayable: observable,
      mdc: observable,
      mdc100: observable,
      autoplayOverlay: observable,
      tourVisible: observable,
      freakingOut: observable,
      set_firstLoad: action,
      setFreakingOut: action,
      setTourVisible: action,
      set_pathname: action,
      set_songTime: action,
      set_mdc: action,
      mdc_str: computed,
      set_mdc100: action,
      set_autoplayable: action,
      set_autoplayOverlay: action,
      set_user_id: action,
      update: action.bound,
      merge: action.bound,
      setDuration: action,
      set_volume: action,
      set_loading: action,
      manage_pause: action,
      setPaused: action,
      toggle_shuffle: action,
      disable_shuffle: action,
      setShuffle: action,
      // peaks_url: computed,
      progress: computed,
      seekTime: computed,
      durationTime: computed,
      song_explicit: computed,
      firstTime: computed,
      volumeDisplay: computed,
      //station_art: computed,
      // album_art: computed,
      // last_song_art: computed,
      // setIdle: action,
      // idle: observable,
      working: observable,
      airplayThumbsOpen: observable,
      get_airplay_overlay: action,
      closeAirplayOverlay: action,
      autoplayOverlayVariant: observable,
      defaultAlbumArtPalette: observable,
      albumArtPalette: observable,
      set_albumArtPalette: action,
      setSongFavorite: action.bound,
      landingPathname: observable,
      setlandingPathname: action,
      signUpOpen: observable,
      setSignUpOpen: action,
      logInOpen: observable,
      setLogInOpen: action,
      airplayUX: observable,
      setAirplayUX: action,
      resuming: observable,
      setResuming: action,
      not_found_artist_name: observable,
      null_not_found_artist_name: action,
      setStationError: action,
      station_error: observable,
      handleRegularTuneIn: action.bound,
      handleSkipSong: action.bound,
      tooManySkipsMessageOpen: observable,
      setTooManySkipsMessageOpen: action,
      snackCopy: observable,
      setSnackCopy: action,
      youtubeID: observable,
      setYoutubeID: action,
      docTitle: computed,
    });

    this.albumArtPalette = this.defaultAlbumArtPalette;

    // console.log("PlayerStore new");
    if (typeof _jm != "undefined" && _jm.song_info) {
      this.songInfo = _jm.song_info;
      // set null because delete is slow?
      _jm.song_info = null;
    }
    //   this.merge({ shuffle: readCookie('_jsmix') > 0 })
    this.shuffle = readCookie("_jsmix") > 0;
    this.user_id = _jm.user_id;
    this.recaptcha_key = _jm.gr;
    this.playerBG = {};
    _jm.gr = null;
    this.firstLoad = true;
    this.not_found_artist_name = _jm.not_found_artist_name;
    _jm.not_found_artist_name = null;
    this.station_error = _jm.station_error;
    _jm.station_error = null;

    const urlParams = new URLSearchParams(window.location.search);
    this.autoplayOverlayVariant = urlParams.get("ao");
  }

  set_albumArtPalette(colorObj) {
    this.albumArtPalette = colorObj;
  }

  set_firstLoad(v) {
    this.firstLoad = v;
  }

  setFreakingOut(v) {
    this.freakingOut = v;
    if (v) {
      this.setTourVisible(false);
    }
  }

  setTourVisible(v) {
    this.tourVisible = v;
  }

  set_pathname(pn) {
    console.log("playerstore pathname", pn, this.prevPathname, this.pathname);
    // instead of react forceupdate and multiple renders on nav
    // for Peekaboo component when
    // link to same url is clicked
    // might introduce some other sideeffects if observe pathname
    if (this.prevPathname === null) {
      this.setlandingPathname(pn);
    }
    this.prevPathname = this.pathname;
    this.pathname = null;
    this.pathname = pn;
  }

  set_songTime(t) {
    this.songTime = t;
    //console.log("songTime", this.songTime);
  }

  escapeStr(str) {
    const escape = document.createElement("textarea");

    escape.textContent = str;
    return escape.innerHTML;

    // const unescapeHTML = (html) => {
    //     escape.innerHTML = html;
    //     return escape.textContent;
    // }
  }

  get docTitle() {
    return this.escapeStr(
      `${this.songInfo.artist}: ${this.songInfo.song} - ${_jm.branding_display}`
    );
  }

  set_mdc(v) {
    this.mdc = v;
  }

  get mdc_str() {
    return ["Most Variety", "More Variety", "Popular Favorites"][this.mdc - 1];
  }

  set_working(v) {
    this.working = v;
  }

  set_mdc100(v) {
    this.mdc100 = v;
    let mdc;
    switch (true) {
      case v <= 33:
        mdc = 3;
        break;
      case v <= 66:
        mdc = 2;
        break;
      case v <= 100:
        mdc = 1;
        break;
      default:
        mdc = 2;
    }
    this.set_mdc(mdc);
  }

  set_autoplayable(v) {
    this.autoplayable = v;
  }

  set_autoplayOverlay(status) {
    this.autoplayOverlay = status;
  }

  // setIdle(v) {
  //   this.idle = v;
  // }

  set_user_id(user_id) {
    this.user_id = user_id;
  }

  update(props) {
    this.songInfo = props;
  }

  merge(props) {
    this.songInfo = { ...this.songInfo, ...props };
  }

  setDuration(d) {
    this.duration = d;
  }

  set_volume(v) {
    this.volume = v;
  }

  set_loading(v) {
    clearTimeout(this.lt);
    this.lt = setTimeout(
      action(
        function () {
          this.loading = v;
        }.bind(this, v)
      ),
      v == false ? 0 : 500
    );
  }

  manage_pause() {
    this.paused = !this.paused; //ctrls && ctrls.isPaused();
  }

  setPaused(v) {
    console.log("setpaused", v);
    this.resuming = false;
    this.paused = v;
  }

  // must update entire object to trigger render in observers
  toggle_shuffle() {
    this.shuffle = !this.shuffle;
  }

  setShuffle(v) {
    this.shuffle = v;
  }

  disable_shuffle() {
    this.shuffle = false;
  }

  // convert seconds to mm:ss, return as string
  strTime(seconds) {
    if (typeof seconds == NaN || !seconds) {
      return "0:00";
    }

    let nSec = Math.floor(seconds);
    let min = Math.floor(nSec / 60);
    let sec = nSec - min * 60;
    return min + ":" + (sec < 10 ? "0" + sec : sec);
  }

  // get peaks_url() {
  //   if (!this.songInfo.url) {
  //     return null;
  //   }
  //   let u = new URL(this.songInfo.url, "https://waveform.jango.com");
  //   u.hostname = "waveform.jango.com";
  //   let p = u.pathname;
  //   p = p.replace("/music", "");
  //   p = p.replace(/\.[^\.]+$/, ".json");
  //   u.pathname = p;
  //   //    console.log("peaks_url", u);
  //   return u.toString();
  // }

  get progress() {
    // console.log("songtime", this.songTime, "duration", this.duration);
    if (!(this.songTime && this.duration)) {
      return 0;
    }

    return (this.songTime * 100) / this.duration;
  }

  get seekTime() {
    return this.strTime(this.songTime);
  }

  get durationTime() {
    return this.strTime(this.duration);
  }

  get song_explicit() {
    return this.songInfo.tags.indexOf("explicit") != -1;
  }

  get firstTime() {
    // return true if no url
    return !this.songInfo.url;
  }

  get volumeDisplay() {
    return `${parseInt(this.volume * 100)}%`;
  }

  // get album_art() {
  //   const { album_art } = this.songInfo;
  //   if (!album_art || !this.retina()) {
  //     return album_art;
  //   }
  //   // i.e. //s03.album.images.jango.com/ec/80/ec80b451566b4d66540f02dbcc76282e_lg.jpg
  //   if (album_art.match(/album/) && album_art.match(/_lg\./)) {
  //     return album_art.replace(/_lg\./, "_xl.");
  //   } else if (
  //     album_art.match(/artist/) &&
  //     !album_art.match(/ra-artist/) &&
  //     album_art.match(/_lg\./)
  //   ) {
  //     // keep _lg artists for now
  //     return album_art; //.replace(/_lg\./, ".");
  //   }

  //   return album_art;
  // }

  get_airplay_overlay() {
    this.airplayThumbsOpen = true;
  }

  closeAirplayOverlay() {
    this.airplayThumbsOpen = false;
  }

  setSongFavorite(v) {
    console.log("setFavorite", v);
    this.merge({ favorite: v });
  }

  setlandingPathname(v) {
    if (this.landingPathname) {
      return;
    }
    this.landingPathname = v;
  }

  setSignUpOpen(v) {
    this.logInOpen = false;
    this.signUpOpen = v;
  }
  setLogInOpen(v) {
    this.signUpOpen = false;
    this.logInOpen = v;
  }

  setAirplayUX(v) {
    this.airplayUX = v;
  }

  setResuming(v) {
    this.resuming = v;
  }

  null_not_found_artist_name() {
    this.station_error = null;
    this.not_found_artist_name = null;
  }

  setStationError(v) {
    this.station_error = v;
  }

  handleSkipSong() {
    this.set_loading(true);
    // this.set_songTime(0);
  }

  handleRegularTuneIn() {
    console.log("handleRegularTuneIn", this.working);
    //    this.setPlayerStopTrigger();
    this.setFreakingOut(false);

    this.set_loading(true);
    if (this.working) {
      return false;
    }
    this.set_working(true);
    // this.set_songTime(0);
    // this.setDuration(0);
  }

  setTooManySkipsMessageOpen(v) {
    this.tooManySkipsMessageOpen = v;
  }
  setSnackCopy(v) {
    this.snackCopy = v;
  }
  setYoutubeID(v) {
    console.log("set video id", v);
    if (v) {
      this.paused = true;
      this.resuming = false;
    } else {
      this.resuming = true;
    }
    this.youtubeID = v;
  }
}

const playerStore = new PlayerStore();

window.playerStore = playerStore;
export default playerStore;

export const playerStoreContext = createContext(playerStore);
